<div class="mct-flex mct-col mct-gap-8"   *ngIf="fileUploadData">
  <label>{{
    fileUploadData.LabelText ? fileUploadData.LabelText : ('form-builder.legos.file-upload.default-label-text' | translate | ucfirst)
  }}</label>
  <p-fileUpload #fileUploader name="files1[]" [showUploadButton]="false" mode="advanced" cancelLabel="Clear" [disabled]="true">
  </p-fileUpload>
</div>
